import {
  SET_TRATAMIENTO,
  SET_SEXO,
  SET_NOMBRE_CONTACTO,
  SET_APELLIDO_MATERNO_CONTACTO,
  SET_APELIIDO_PATERNO_CONTACTO,
  SET_ESTADO_CONTACTO,
  SET_CIUDAD_CONTACTO,
  SET_ID_CONCESIONARIO_CONTACTO,
  SET_CONCESIONARIO_CONTACTO,
  SET_TELEFONO_CONTACTO,
  SET_MOVIL_CONTACTO,
  SET_CORREO_CONTACTO,
  SET_COMENTARIOS_CONTACTO,
  SET_AVISO_PRIVACIDAD_CONTACTO,
  SET_TERMINOS_Y_CONDICIONES_CONTACTO,
  SET_TRANSFERENCIA_DE_DATOS_CONTACTO,
  SET_CONTACO_MARKETING_CONTACTO,
  SET_VEIHICULO_CONTACTO,
  SET_TIPO_CITA_CONTACTO,
  RESET_STATE_CONTACTO,
  SET_VIN_CONTACTO,
} from "../types";

const initialState = {
  fuenteSitioWeb: "Sitio Web Audi",
  marca: "Audi",
  tipoRegistro: "",
  fuenteSecundaria: "",
  tercerNivel: "",
  llaveOrigen: "",
  tratamiento: "Sr",
  sexo: "Masculino",
  nombre: "",
  apellidoMaterno: "",
  apellidoPaterno: "",
  telefono: "",
  celular: "",
  email: "",
  ciudad: "",
  provincia: "",
  concesionariaPreferida: "",
  vehiculoActual: "",
  descripcion: "",
  permisoTransferenciaDatos: false,
  permisoContactoMarketing: false,
  urlWeb: "",
  tipoCita: "Contacto",
  fechaNacimiento: "",
  numeroConcesionaria: "",
  horarioPreferente: "",
  fechaPreferente: "",
  vehiculoInteres: "",
  urlPrivacidad: "",
  status: "",
  fbCampaignID: "",
  avisoPrivacidad: false,
  terminosCondiciones: false,
  nombreDelVehiculo: "",
  vin: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TRATAMIENTO:
      return {
        ...state,
        tratamiento: action.payload,
      };
    case SET_SEXO:
      return {
        ...state,
        sexo: action.payload,
      };
    case SET_NOMBRE_CONTACTO:
      return {
        ...state,
        nombre: action.payload,
      };
    case SET_APELLIDO_MATERNO_CONTACTO:
      return {
        ...state,
        apellidoMaterno: action.payload,
      };
    case SET_APELIIDO_PATERNO_CONTACTO:
      return {
        ...state,
        apellidoPaterno: action.payload,
      };
    case SET_ESTADO_CONTACTO:
      return {
        ...state,
        provincia: action.payload,
      };
    case SET_CIUDAD_CONTACTO:
      return {
        ...state,
        ciudad: action.payload,
      };
    case SET_ID_CONCESIONARIO_CONTACTO:
      return {
        ...state,
        numeroConcesionaria: action.payload,
      };
    case SET_CONCESIONARIO_CONTACTO:
      return {
        ...state,
        concesionariaPreferida: action.payload,
      };
    case SET_TELEFONO_CONTACTO:
      return {
        ...state,
        telefono: action.payload,
      };
    case SET_MOVIL_CONTACTO:
      return {
        ...state,
        celular: action.payload,
      };
    case SET_CORREO_CONTACTO:
      return {
        ...state,
        email: action.payload,
      };
    case SET_COMENTARIOS_CONTACTO:
      return {
        ...state,
        descripcion: action.payload,
      };
    case SET_AVISO_PRIVACIDAD_CONTACTO:
      return {
        ...state,
        avisoPrivacidad: action.payload,
      };
    case SET_TERMINOS_Y_CONDICIONES_CONTACTO:
      return {
        ...state,
        terminosCondiciones: action.payload,
      };
    case SET_TRANSFERENCIA_DE_DATOS_CONTACTO:
      return {
        ...state,
        permisoTransferenciaDatos: action.payload,
      };
    case SET_CONTACO_MARKETING_CONTACTO:
      return {
        ...state,
        permisoContactoMarketing: action.payload,
      };
    case SET_VEIHICULO_CONTACTO:
      return {
        ...state,
        vehiculoInteres: action.payload,
      };
    case SET_TIPO_CITA_CONTACTO:
      return {
        ...state,
        tipoCita: action.payload,
      };
    case SET_VIN_CONTACTO:
      return {
        ...state,
        vin: action.payload,
      };
    case RESET_STATE_CONTACTO:
      return initialState;
    default:
      return state;
  }
}
